/**
 * Functions that helps the URL
 *
 * @packageDocumentation
 */

/**
 * Check if external URL based on the target URL
 */
export const getHrefExternal = (input: string): boolean => {
    let url: URL

    try {
        url = new URL(input)
    } catch (_) {
        return false
    }

    if (url.hostname !== window.location.hostname) {
        return true
    }
    return false
}
